import { PricingItemMap } from '@atlassian/mpac-pricing-utils';
export const getInstallCTALabelAndHref = (isFreeApp, canUserInstallApp, installAppHrefResolver, requestAppHrefResolver, selectedSiteAndProduct, paidLicenseActiveOnParent) => {
  if (!selectedSiteAndProduct) {
    return {
      installCTALabel: 'Start free trial'
    };
  }
  if (!canUserInstallApp) {
    return {
      installCTALabel: 'Request app',
      installCTAHref: requestAppHrefResolver(selectedSiteAndProduct)
    };
  }
  const installCTALabel = isFreeApp ? 'Add app' : paidLicenseActiveOnParent ? 'Add to sandbox' : 'Start free trial';
  return {
    installCTALabel,
    installCTAHref: installAppHrefResolver(selectedSiteAndProduct, true)
  };
};
const mapPricingItems = pricingPlan => {
  var _pricingPlan$tieredPr;
  return (_pricingPlan$tieredPr = pricingPlan === null || pricingPlan === void 0 ? void 0 : pricingPlan.tieredPricing.items.map(item => {
    var _item$ceiling;
    return {
      amount: item.amount,
      currencyCode: pricingPlan.currency,
      unitCount: (_item$ceiling = item.ceiling) !== null && _item$ceiling !== void 0 ? _item$ceiling : item.floor,
      type: PricingItemMap[item.policy]
    };
  })) !== null && _pricingPlan$tieredPr !== void 0 ? _pricingPlan$tieredPr : [];
};
export const getPricingPlanItems = appPricing => {
  const {
    monthlyPricingPlan,
    annualPricingPlan
  } = appPricing;
  return {
    monthly: mapPricingItems(monthlyPricingPlan),
    annual: mapPricingItems(annualPricingPlan)
  };
};